<template>
  <div class="radio-button-wrapper">
    <input
      type="radio"
      ref="radioInput"
      :id="id"
      :name="name"
      :checked="isChecked"
      :value="value"
      @input="input">
    <label v-bind:for="id">{{text}}</label>
    <div class="radio-dot"></div>
  </div>
</template>

<script>
  export default {
    name: "UXRadioButton",
    props: {
      id: String,
      name: String,
      text: String,
      isChecked: Boolean,
      value: String
    },
    methods: {
      input () {
        this.$emit('input', this.$refs.radioInput.value);
      }
    }
  };
</script>
